import { openModal, closeModal } from '../lib/modal.js';

// Replaces window.prompt(text, defaultValue) for quick numeric edits (e.g. "fix the weight
// I just logged", "correct an archived weight entry") — prompt() is unreliable in iOS
// standalone mode, same bug class as confirm(). onSave receives the parsed float, or is
// never called if the user cancels or types something invalid.
let _onSave = null;

export function openValuePrompt(title, initialValue, onSave, opts = {}) {
  document.getElementById('valuePromptTitle').textContent = title;
  const inp = document.getElementById('valuePromptInp');
  inp.value = initialValue ?? '';
  inp.style.borderColor = '';
  inp.step = opts.step || '0.1';
  _onSave = onSave;
  openModal('shValuePrompt');
  setTimeout(() => { inp.focus(); inp.select(); }, 200);
}

export function confirmValuePrompt() {
  const inp = document.getElementById('valuePromptInp');
  const v = parseFloat(String(inp.value).replace(',', '.'));
  if (isNaN(v)) { inp.style.borderColor = 'var(--red)'; return; }
  const cb = _onSave;
  _onSave = null;
  closeModal('shValuePrompt');
  if (cb) cb(v);
}
